module.exports = __webpack_public_path__ + "img/1584978757.51ca48df.jpg";